<template>
    <div class="foot">
        <div class="foot-top">
            <div class="foot-top-main">
                <div class="foot-top-main-left">
                    <div class="foot-top-main-left-top">
                        <img src="../../assets/images/logo2.png" alt="" @click="home">
                    </div>
                    <div class="foot-top-main-left-bottom">
                        <div><span class="span-left" v-t="'Front_desk_switchboard'"></span><span class="span-right">139 1163 1843</span></div>
                        <div><span class="span-left" v-t="'Pre_sales_consultation'"></span><span class="span-right">153 0274 9336</span></div>
                        <div><span class="span-left" v-t="'Contact_customer_service'"></span><span class="span-right">135 3035 5336</span></div>
                    </div>
                </div>
                <div class="foot-top-main-right">
                    <div class="foot-top-main-right-left">
                        <div class="import-div">
                            <h3 v-t="'About_rice'"></h3>
                            <ul>
                                <li v-t="'Company_qualification'" @click="about"></li>
                                <li v-t="'Cooperative_partner'" @click="partner"></li>
                                <li v-t="'Recruitment_information'" @click="recruit"></li>
<!--                                <li @click="shop" v-t="'shop'"></li>-->
<!--                                <li @click="upload">应用上传</li>-->
                            </ul>
                        </div>
                        <div>
                            <h3 v-t="'Industrial_gateway'"></h3>
                            <ul>
                                <li @click="gc111">GC111</li>
                                <li @click="t300">T300</li>
                                <li @click="m55">M55</li>
                                <li @click="lm321">LM321</li>
                            </ul>
                        </div>
                        <div>
                            <h3 v-t="'Data_terminal_products'"></h3>
                            <ul>
                                <li @click="cpeLC111">LC111</li>
                                <li @click="t115">T115</li>
                                <li @click="ldw931">LDW931</li>
                            </ul>
                        </div>
                    </div>
                    <div class="foot-top-main-right-right">
                        <img src="../../assets/images/code0.jpg" alt="">
                        <span v-t="'Wechat_public_platform'"></span>
                    </div>
                    <div class="foot-top-main-right-right">
                        <div id="qrcode" style="border: 5px solid white"></div>
                        <span v-t="'Electronic_instruction_manual'"></span>
                    </div>
                    <!-- <div class="foot-top-main-right-right">
                        <div id="service" style="border: 5px solid white" @click="generateQRCode"></div>
                        <span v-t="'Human_customer_service'"></span>
                    </div> -->
                    <div class="foot-top-main-right-right">
                        <img src="../../assets/images/code2.png" alt="" id="service">
                        <span v-t="'Human_customer_service'"></span>
                    </div>
                </div>
            </div>
        </div>
        <div class="foot-bottom">
            <div class="foot-bottom-main">
                <div class="foot-bottom-main-left">
                    <div class="import-child" v-t="'Rice'"></div>
                    <div><a href="https://beian.miit.gov.cn" target="_blank" v-t="'Yue_Hao'" class="Yue-Hao"></a></div>
                    <div v-t="'Rhinoceros_cloud'"></div>
                </div>
                <div class="foot-bottom-main-right">
                    <img src="../../assets/images/data.png" alt="">
                </div>
            </div>
            <div class="back" @click="toTop">
                <i class="el-icon-arrow-up"></i>
            </div>
            <div class="qin">琴</div>
        </div>
    </div>
</template>

<script>
    import QRCode from 'qrcodejs2';

    export default {
        name: "Foot",
        components: {
            QRCode
        },

        mounted() {
            const qrcode = document.getElementById('qrcode');
            new QRCode(qrcode, {
                text: "http://www.mifidata.cn/manual",
                width: 90,
                height: 90,
                colorDark : "#000",
                colorLight : "#fff",
                correctLevel : QRCode.CorrectLevel.H
            });
            qrcode.setAttribute('title', '');

    
            // this.generateQRCode();
        },

        methods: {
            // 生成随机二维码
            // generateQRCode() {
            //     const service = document.getElementById('service');
            //     const randomValue = Date.now();
            //     const baseUrl = "http://www.mifidata.cn/service";
            //     const newUrl = `${baseUrl}?code=${randomValue}`;
            //     service.innerHTML = "";
            //     new QRCode(service, {
            //         text: newUrl,
            //         width: 90,
            //         height: 90,
            //         colorDark: "#000",
            //         colorLight: "#fff",
            //         correctLevel: QRCode.CorrectLevel.H
            //     });
            //     service.setAttribute('title', ''); 
            // },
            
            toTop() {
                let top = document.documentElement.scrollTop || document.body.scrollTop;
                // 实现滚动效果
                const timeTop = setInterval(() => {
                    document.body.scrollTop = document.documentElement.scrollTop = top -= 50;
                    if (top <= 0) {
                        clearInterval(timeTop);
                    }
                }, 10);
            },
            home(){
                this.$router.push("/")
            },
            about(){
                this.$router.push("/about")
            },
            partner(){
                this.$router.push("/partner")
            },
            recruit(){
                this.$router.push("/recruit")
            },
            shop(){
                this.$router.push("/shop")
            },
            upload(){
                this.$router.push("/upload")
            },
            gc111(){
                this.$router.push("/gc111")
            },
            t300(){
                this.$router.push("/t300")
            },
            m55(){
                this.$router.push("/m55")
            },
            lm321(){
                this.$router.push("/lm321")
            },
            cpeLC111(){
                this.$router.push("/cpeLC111")
            },
            t115(){
                this.$router.push("/t115")
            },
            ldw931(){
                this.$router.push("/ldw931")
            },
        },
    }
</script>

<style scoped>
    .foot{
        width: 100%;
    }
    .foot-top{
        width: 100%;
        background-color: #444444;
    }
    .foot-top-main{
        width: 1000px;
        padding: 30px 0;
        margin: 0 auto;
        display: flex;
        justify-content: space-between;
        color: #f8f8f8;
    }
    .foot-top-main-left{
        width: 24%;
        border-right: 1px solid #f8f8f8;
        display: flex;
        flex-direction: column;
    }
    .foot-top-main-left-top{
        text-align: left;
        width: 100%;
    }
    .foot-top-main-left-top img{
        cursor: pointer;
    }
    .foot-top-main-left-bottom{
        width: 100%;
        display: flex;
        flex-direction: column;
        margin-top: 15px;
    }
    .foot-top-main-left-bottom div{
        padding: 3px 15px  3px  0;
        display: flex;
        align-items: center;
        justify-content: center;
        font-size: 14px;
    }
    .span-left,.span-right{
        display: flex;
        justify-content: left;
        align-items: center;
    }
    .span-left,.span-right{
        width: 50%;
    }
    .foot-top-main-right{
        width: 75%;
        margin-left: 25px;
        display: flex;
        justify-content: space-between;
    }
    .foot-top-main-right-left{
        display: flex;
    }
    .foot-top-main-right-left div{
        text-align: left;
        margin: 0 15px;
    }
    .foot-top-main-right-left div h3{
        margin-top: 0;
    }
    .foot-top-main-right-left div ul{
        padding-left: 0;
        text-align: left;
    }
    .foot-top-main-right-left div ul li{
        padding: 5px 3px;
        cursor: pointer;
        font-size: 14px;
    }
    .import-div{
        margin-left: 0!important;
    }
    .foot-top-main-right-right{
        display: flex;
        flex-direction: column;
        padding: 20px 0;
    }
    .foot-top-main-right-right span{
        margin-top: 15px;
    }
    .foot-bottom{
        width: 100%;
        background-color: #000000;
        color: #f8f8f8;
        font-size: 12px;
        position: relative;
    }
    .foot-bottom-main{
        width: 1000px;
        padding: 10px 0;
        margin: 0 auto;
        display: flex;
        justify-content: space-between;
        align-items: center;
    }
    .foot-bottom-main-left{
        display: flex;
    }
    .foot-bottom-main-left div{
        margin-left: 30px;
    }
    .foot-bottom-main-left div a{
        color: #f8f8f8;
    }
    .import-child{
        margin-left: 0!important;
    }
    .Yue-Hao:hover{
        color: orange;
    }
    .back{
        position: absolute;
        right: 30px;
        top: -25px;
        width: 50px;
        height: 50px;
        border-radius: 50%;
        background-color: #ccc;
        cursor: pointer;
        display: flex;
        justify-content: center;
        align-items: center;
    }
    .back:hover{
        background-color: orangered;
    }
    .back i{
        font-size: 35px;
        font-weight: bold;
    }
    .qin{
        position: absolute;
        left: 0px;
        bottom: 0px;
        font-size: 12px;
        color: rgb(36, 32, 32);
    }
</style>



